import { useSelectedProjectElementNode } from 'components/WorkspaceEditor/Workspace2Store'
import { useOMWorkspace } from 'shared/hooks/useOMWorkspace'
import { isOMBestPracticeFeatureEnabled } from 'shared/utils/bestPracticeUtils'
import { BestPracticeContentItem, useBestPracticesData } from './useBestPracticesData'
import { useBestPracticesDisplay } from './useBestPracticesDisplay'

/**
 * Single source of truth for whether the BP/GBP icon should render for a given
 * content item. Encapsulates all conditions shared between BestPracticesIconWrapper
 * and the NodeTitle margin gate, so the two can never drift apart.
 *
 * NodeTitle-specific guards (node type, feature flag) are still checked by the
 * caller — this hook only covers the conditions that BestPracticesIconWrapper
 * also checks internally.
 */
export const useShouldRenderBPIcon = (
    contentItem: BestPracticeContentItem
): boolean => {
    const { shouldDisplayBPIcon } = useBestPracticesDisplay(contentItem)
    const { isBestPractice, isGlobalBestPractice } = useBestPracticesData(contentItem)
    const { isCurrentlyOnOMWorkspace } = useOMWorkspace()
    const isBPManagementEnabled =
        isOMBestPracticeFeatureEnabled() && isCurrentlyOnOMWorkspace
    const selectedProjectElementNode = useSelectedProjectElementNode()

    return (
        shouldDisplayBPIcon &&
        (isBestPractice || isGlobalBestPractice) &&
        !(isCurrentlyOnOMWorkspace && !isBPManagementEnabled) &&
        Boolean(selectedProjectElementNode?.isInProject)
    )
}
